import { useState } from "react";
import { PRESET_LABELS, type PresetId } from "../model/presets";
import { useApp } from "../state/store";

/** Presets et partage. */
export function Outils() {
  const applyPreset = useApp((s) => s.applyPreset);
  const route = useApp((s) => s.route)!;
  const [copie, setCopie] = useState(false);

  const partager = async () => {
    const url = location.href;
    try {
      if (navigator.share && /Mobi|Android/i.test(navigator.userAgent)) {
        await navigator.share({ title: "Où mettre les gares ? — mon scénario Réunion Express", url });
        return;
      }
      await navigator.clipboard.writeText(url);
    } catch {
      window.prompt("Copiez ce lien :", url);
    }
    setCopie(true);
    setTimeout(() => setCopie(false), 2000);
  };

  const presets: PresetId[] = ["reference", "express", "omnibus", "vide"];
  const nRef = route.reference_stations.length;
  const nExp = route.reference_stations.filter((s) => s.express).length;
  const compte: Record<PresetId, string> = { reference: `${nRef}`, express: `${nExp}`, omnibus: "40", vide: "2" };

  return (
    <section className="outils">
      <p className="aide">Touchez le tracé pour poser une gare, glissez une gare pour la déplacer, touchez une gare grisée pour la remettre.</p>
      <div className="presets" role="group" aria-label="Scénarios prédéfinis">
        {presets.map((p) => (
          <button type="button" key={p} onClick={() => applyPreset(p)}>
            {PRESET_LABELS[p]} <small>{compte[p]} gares</small>
          </button>
        ))}
      </div>
      <div className="actions">
        <button type="button" className="primaire" onClick={() => void partager()}>
          {copie ? "Lien copié ✓" : "Partager mon scénario"}
        </button>
      </div>
    </section>
  );
}
